import { BASE_ADMIN_PATH, BASE_ADMIN_V2_PATH } from '../../admin/constants/path.constants';

export const ADMIN_STATISTICS_ROOT = `${BASE_ADMIN_PATH}/statistics`;
export const ADMIN_STATISTICS_V2_ROOT = `${BASE_ADMIN_V2_PATH}/statistics`;

export const ADMIN_STATISTICS_APP_PATHS = {
  OVERVIEW: `${ADMIN_STATISTICS_ROOT}/overview`,
  COMMISSIONS: `${ADMIN_STATISTICS_ROOT}/commissions`,
  SALES: `${ADMIN_STATISTICS_ROOT}/sales`,
};

export const ADMIN_STATISTICS_V2_APP_PATHS = {
  OVERVIEW: `${ADMIN_STATISTICS_V2_ROOT}/overview`,
  COMMISSIONS: `${ADMIN_STATISTICS_V2_ROOT}/commissions`,
  SALES: `${ADMIN_STATISTICS_V2_ROOT}/sales`,
};

export const ADMIN_STATISTICS_API_PATHS = {
  COMMISSIONS: `${ADMIN_STATISTICS_ROOT}/commissions`,
};
